import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { StoxlyClient } from '@stoxly/api-client';
import type { Query } from '../op-types';

export function createPeerQueries(client: StoxlyClient) {
  return createQueryKeys('peers', {
    // ['peers', 'detail', symbol, ...]
    detail: (symbol: string) => ({
      queryKey: [symbol],
      contextQueries: {
        streamPeers: (query?: Query<'peerDiscoveryStreamPeers'>) => ({
          queryKey: [{ query }],
          queryFn: ({ signal }) =>
            client.peerDiscoveryStreamPeers({ params: { symbol }, queries: query, signal }),
        }),
      },
    }),
  });
}
